import { Editor } from "..";
import { ICampaignStore } from "../../campaign-store";
import { AdsEditorUtils } from "../../hooks/useAdsEditorUtils";
import { IImagesStore } from "../../images-store";
import { EditorConfig, IScene } from "../../types";
import { ControllerOptions, EditorState, FabricCanvas } from "../common/interfaces";

class Base {
	protected canvas: FabricCanvas;
	protected config: EditorConfig;
	protected editor: Editor;
	protected state: EditorState;
	public campaignStore: ICampaignStore;
	public adsEditorUtils: AdsEditorUtils;
	public imagesStore: IImagesStore;
	public setCurrentScn: (scene: IScene | null, invokeSave?: boolean) => void;

	constructor({
		canvas,
		config,
		editor,
		state,
		campaignStore,
		adsEditorUtils,
		imagesStore,
		setCurrentScn,
	}: ControllerOptions) {
		this.canvas = canvas;
		this.config = config;
		this.editor = editor;
		this.state = state;
		this.campaignStore = campaignStore;
		this.adsEditorUtils = adsEditorUtils;
		this.setCurrentScn = setCurrentScn;
		this.imagesStore = imagesStore;
	}
}

export default Base;
